import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white" data-id="element-23">
      <div className="container mx-auto px-4 py-12" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-25">
          <div data-id="element-26">
            <Link to="/" className="text-2xl font-bold mb-4 block" data-id="element-27">
              <span className="text-white" data-id="element-28">Raw</span>
              <span className="text-gray-400" data-id="element-29">founders</span>
            </Link>
            <p className="text-gray-300 mt-4" data-id="element-30">
              A corporate umbrella brand with multiple verticals spanning real
              estate, technology, and AI solutions.
            </p>
          </div>
          <div data-id="element-31">
            <h3 className="text-lg font-semibold mb-4 text-gray-400" data-id="element-32">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-33">
              <li data-id="element-34">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-35">
                  Home
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/about" className="text-gray-300 hover:text-white" data-id="element-37">
                  About Us
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/ventures" className="text-gray-300 hover:text-white" data-id="element-39">
                  Our Services
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/contact" className="text-gray-300 hover:text-white" data-id="element-41">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-42">
            <h3 className="text-lg font-semibold mb-4 text-gray-400" data-id="element-43">
              Our Business
            </h3>
            <ul className="space-y-2" data-id="element-44">
              <li data-id="element-45">
                <Link to="/rawfound-properties" className="text-gray-300 hover:text-white" data-id="element-46">
                  Rawfound Properties
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/shoplinky" className="text-gray-300 hover:text-white" data-id="element-48">
                  Shoplinky
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/agentter" className="text-gray-300 hover:text-white" data-id="element-50">
                  Agentter.ai
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-51">
            <h3 className="text-lg font-semibold mb-4 text-gray-400" data-id="element-52">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-53">
              <li className="flex items-start" data-id="element-54">
                <MapPinIcon className="h-5 w-5 mr-2 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-55" />
                <div className="text-gray-300" data-id="element-56">
                  <p className="font-medium" data-id="element-57">Dubai (Headquarters)</p>
                  <p data-id="element-58">Lincoln Park, Barsha South, Dubai, UAE</p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-59">
                <MapPinIcon className="h-5 w-5 mr-2 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-60" />
                <div className="text-gray-300" data-id="element-61">
                  <p className="font-medium" data-id="element-62">Bangalore</p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-63">
                <MapPinIcon className="h-5 w-5 mr-2 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-64" />
                <div className="text-gray-300" data-id="element-65">
                  <p className="font-medium" data-id="element-66">London</p>
                </div>
              </li>
              <li className="flex items-center" data-id="element-67">
                <PhoneIcon className="h-5 w-5 mr-2 text-gray-400" data-id="element-68" />
                <span className="text-gray-300" data-id="element-69">+971-564684336</span>
              </li>
              <li className="flex items-center" data-id="element-70">
                <MailIcon className="h-5 w-5 mr-2 text-gray-400" data-id="element-71" />
                <span className="text-gray-300" data-id="element-72">Ramzad@rawfounders.com</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4" data-id="element-73">
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-74">
                <LinkedinIcon className="h-5 w-5" data-id="element-75" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-76">
                <TwitterIcon className="h-5 w-5" data-id="element-77" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-6 text-center text-gray-400 text-sm" data-id="element-78">
          <p data-id="element-79">
            &copy; {new Date().getFullYear()} Rawfounders. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}